import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'LIMS Reports - Descriptive Information (DESC)';
  version = '0.11.2';
  user = 'guest';
  password = '';
  database = 'Shore';
  selectedExpedition = '';
  selectedSite = '';
  seletedHole = '';
}
